import { render, staticRenderFns } from "./report-scoring.vue?vue&type=template&id=468ecbc6"
import script from "./report-scoring.vue?vue&type=script&lang=js"
export * from "./report-scoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports